import { gql, TypedDocumentNode } from '@common/hooks';
import {
  DoNotRehireQueryQueryCgResponse,
  DoNotRehireQueryQueryVariables,
} from '@common/graphql';

export type DoNotRehireType = DoNotRehireQueryQueryCgResponse['doNotRehire'];

export const DO_NOT_REHIRE_QUERY: TypedDocumentNode<
  DoNotRehireQueryQueryCgResponse,
  DoNotRehireQueryQueryVariables
> = gql`
  query DoNotRehireQuery(
    $identificationCode: String!
    $organizationId: ID!
    $organizationBusinessId: ID!
    $organizationUnitId: ID!
  ) {
    doNotRehire(
      identificationCode: $identificationCode
      organizationId: $organizationId
      organizationBusinessId: $organizationBusinessId
      organizationUnitId: $organizationUnitId
    ) {
      id
      identificationCode
      reason
      institutionLevel
      expiration
      createdAt
      updatedAt
      authorName
      endsAt
      supplier {
        id
      }
    }
  }
`;
